export const N9_GROUP_URL = 'https://n9-group-ashy.vercel.app/';
export const N9_GROUP_LABEL = 'N9 GROUP';
export const N9_SYSTEM_URL = 'https://n9-law-system.n9-law-system.workers.dev/';
